import React, { useState, useContext, useRef, useEffect } from "react";
import { GlobalContext } from "../../context/provider";
import { MdDone, MdOutlineClose, MdKeyboardArrowDown, MdSearch, MdDeleteForever } from "react-icons/md";
import deleteaction from "../../context/action/sell/deleteaction";
import getitemaction from "../../context/action/return/getitemaction";
import createaction from "../../context/action/return/createaction";
import getitemrecommendaction from "../../context/action/item/getitemrecommendaction";
import numberbeautify from "../../utils/numberbeautify";
import money_rounding from "../../utils/money_rounding";
import iqd_rounding from "../../utils/iqd_rounding";
import updateaction from "../../context/action/sell/updateaction";
import { Sellitemprint } from "./sellitemprint";
import { useReactToPrint } from "react-to-print";

const Sellinvoicedetailmodal = (props) => {
  const { initState, recaller, setrecaller, clear, initDispatch } =
    useContext(GlobalContext);

  useEffect(() => {
      const handleClickOutside = (event) => {
          if (barcodeRef.current && !barcodeRef.current.contains(event.target)) {
              // setIsOpen(false);
              setitem_suggestion([]);
          }
      };
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const [barcode, setbarcode] = useState();
  const [item_suggestion,setitem_suggestion] = useState([]);

  const barcodeRef = useRef(null);
  const printRef = useRef();
  
  const printFn = useReactToPrint({
      contentRef: printRef,
      documentTitle: "AwesomeFileName",
      preserveAfterPrint: true,
      print: (printIframe) =>
      new Promise(() => {
        printIframe.style.display = "none";

        printIframe.contentWindow?.print();
      }),
  });

  const [sell_loading, setsell_loading] = useState(false);
  const [error, seterror] = useState(false);
  const [error1, seterror1] = useState(false);
  const [error2, seterror2] = useState(false);
  const [error3, seterror3] = useState(false);
  const [error4, seterror4] = useState(false);
  const [error5, seterror5] = useState(false);
  const [error6, seterror6] = useState(false);
  return (
    <>
      {props.show ? (
        <>
        {/* <div style={{display:'none'}}> */}
        <div
          style={{
            position: 'absolute',
            left: '-99999px',
            top: 0
          }}
        >
          <Sellitemprint ref={printRef} invoiceno={props?.invoice_detail?.sell_invoice_id} sell_invoice_type={props?.invoice_detail?.sell_invoice_type} loan_back_amount={props?.invoice_detail?.sell_invoice_loan_in_amount} remained_loan={props?.invoice_detail?.customer_loan} sell_invoice_discount={props?.invoice_detail?.sell_invoice_discount} sell_invoice_dollar_price={props?.invoice_detail?.sell_invoice_dollar_price} customer_name={props?.invoice_detail?.sell_invoice_customer_name} customer_address={props?.invoice_detail?.sell_invoice_customer_address} customer_phone={props?.invoice_detail?.sell_invoice_customer_phone} sell_invoice_date={props?.invoice_detail?.sell_invoice_date} items={props?.invoice_detail?.items} />
          {/* <div ref={printRef}>
            <h1>Hello World</h1>
            <p>{Date.now()}</p>
          </div> */}
        </div>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none p-2 sm:p-4">
            <div className="relative my-6 mx-auto w-full max-w-[90%]">
              {/*content*/}
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                {/*header*/}
                <div className="flex items-center justify-between p-4 border-b border-solid border-slate-200 rounded-t">
                  <h3 className="text-xl sm:text-3xl uppercase font-semibold flex-1">
                    گۆڕانکاری
                  </h3>
                  <button
                    className="p-1 bg-transparent border-0 text-black text-3xl opacity-80 leading-none font-semibold outline-none focus:outline-none"
                    onClick={() => {
                      props.setshow(false);
                      props.setinvoice_detail();
                      setbarcode("");
                    }}
                  >
                    <span className="bg-transparent text-black h-6 w-6 text-2xl block outline-none focus:outline-none">
                      X
                    </span>
                  </button>
                </div>
                {/*body*/}
                <div className="relative max-h-[calc(100vh-15rem)] overflow-y-auto p-4 sm:p-6 flex-auto">
                  <div className="flex flex-wrap w-full -mx-3">
                    <div className="w-full md:w-1/3 px-3 mb-4 md:mb-0">
                      <label
                        htmlFor="invoice_type"
                        className={"block mb-1 text-sm font-medium text-gray-700"}
                      >
                        جۆری وەسڵ
                      </label>
                      <select
                        id="invoice_type"
                        disabled={props?.invoice_detail?.customer_id==1?true:false}
                        className={
                          props?.invoice_detail?.customer_id==1
                          ? "bg-gray-200 border border-gray-300 text-gray-500 rounded cursor-not-allowed block w-full py-3 px-4 h-12"
                          : "bg-gray-50 border border-gray-300 text-gray-700 rounded focus:ring-blue-500 focus:border-blue-500 block w-full py-3 px-4 h-12"
                        }
                        value={props?.invoice_detail?.sell_invoice_type}
                        onChange={(val) => props?.setinvoice_detail({...props?.invoice_detail, sell_invoice_type: val.target.value})}
                      >
                        <option value="cash">کاش</option>
                        <option value="loan">قەرز</option>
                      </select>
                    </div>
                    <div className="w-full md:w-1/3 px-3 mb-4 md:mb-0">
                      <label
                        className={
                          error1
                            ? "block uppercase tracking-wide text-red-500 text-xs font-bold mb-2"
                            : "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        }
                        htmlFor="sell_invoice_discount"
                      >
                        داشکاندن
                      </label>
                      <input
                        className={
                          error1
                            ? "appearance-none block w-full bg-gray-50 text-gray-700 border border-red-500 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12"
                            : "appearance-none block w-full bg-gray-50 text-gray-700 border border-gray-300 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12"
                        }
                        id="sell_invoice_discount"
                        type="number"
                        placeholder=""
                        onClick={(val)=>{val.target.select()}}
                        value={props?.invoice_detail?.sell_invoice_discount}
                        onChange={(val) => props?.setinvoice_detail({...props?.invoice_detail, sell_invoice_discount: val.target.value})}
                        onFocus={() => seterror1(false)}
                      />
                    </div>
                    <div className="w-full md:w-1/3 px-3 mb-4 md:mb-0">
                      <label
                        className={
                          error2
                            ? "block uppercase tracking-wide text-red-500 text-xs font-bold mb-2"
                            : "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        }
                        htmlFor="sell_invoice_dollar_price"
                      >
                        نرخی دۆلار
                      </label>
                      <input
                        className={
                          error2
                            ? "appearance-none block w-full bg-gray-50 text-gray-700 border border-red-500 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12"
                            : "appearance-none block w-full bg-gray-50 text-gray-700 border border-gray-300 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12"
                        }
                        id="sell_invoice_dollar_price"
                        type="number"
                        placeholder=""
                        onClick={(val)=>{val.target.select()}}
                        value={props?.invoice_detail?.sell_invoice_dollar_price}
                        onChange={(val) => props?.setinvoice_detail({...props?.invoice_detail, sell_invoice_dollar_price: val.target.value})}
                        onFocus={() => seterror2(false)}
                      />
                    </div>
                  </div>
                  {/* {customer_id==1&&(
                    <div className="flex flex-wrap w-full">
                      <div className="w-full md:w-1/3 px-3">
                        <label
                          className={
                            error4
                              ? "block uppercase tracking-wide text-red-500 text-xs font-bold mb-2"
                              : "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                          }
                          for="sell_invoice_customer_name"
                        >
                          نرخی دۆلار
                        </label>
                        <input
                          className={
                            error4
                              ? "appearance-none block w-full bg-gray-50 text-gray-700 border border-red-500 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                              : "appearance-none block w-full bg-gray-50 text-gray-700 border border-gray-300 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                          }
                          id="sell_invoice_customer_name"
                          type="number"
                          placeholder=""
                          onClick={(val)=>{val.target.select()}}
                          value={props?.invoice_detail?.sell_invoice_customer_name}
                          onChange={(val) => props?.setinvoice_detail({...props?.invoice_detail, sell_invoice_customer_name: val.target.value})}
                          onFocus={() => seterror4(false)}
                        />
                      </div>
                    </div>
                  )} */}
                  <div className="flex flex-wrap w-full">
                    <div className="w-full px-3 my-2 relative">
                      <label
                        className={
                          "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 my-3"
                        }
                        htmlFor="grid-last-name"
                      >
                        ناوی ئایتم / باڕکۆد
                      </label>
                      <input
                        className={
                          "appearance-none block w-full bg-white text-black border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                        }
                        id="grid-last-name"
                        type="text"
                        placeholder=""
                        onClick={(val)=>{val.target.select()}}
                        value={barcode}
                        onChange={(val) => {
                          setbarcode(val.target.value);
                          getitemrecommendaction(val.target.value)(recaller)(setrecaller)(item_suggestion)(setitem_suggestion)(setbarcode)(clear);
                        }}
                        autoFocus
                        // onKeyDown={(key) => {
                        //   if (key.key == "Enter") {
                        //     getitemaction(barcode)(recaller)(setrecaller)(
                        //       items
                        //     )(setitems)(setbarcode)(props.invoice_detail.items);
                        //   }
                        // }}
                      />
                      {item_suggestion.length>0&&barcode.length>0&&(
                        <div ref={barcodeRef} className="absolute left-3 right-3 mt-2 max-h-48 overflow-y-auto bg-white shadow-lg rounded-md z-10">
                          {item_suggestion.map((item, index) => (
                            <div
                              key={index}
                              className={item.item_qty>0?"px-4 py-2 hover:bg-gray-100 cursor-pointer":"px-4 py-2 bg-red-300 hover:bg-red-400 cursor-pointer"}
                              onClick={() => {
                                setbarcode("");
                                setitem_suggestion([]);
                                if (item.item_qty <= 0) {
                                  alert("یەکەی پێویست لەم خاڵایە لە مەخزەن نییە");
                                  return false;
                                }
                                if(props?.invoice_detail?.items?.find((lis) => lis.item_id == item.item_id)){
                                    alert("ئەم کاڵایە پێشتر زیاد کراوە");
                                    // props.setinvoice_detail({
                                    //   ...props.invoice_detail,
                                    //   items: props.invoice_detail.items.map((lis) => lis.item_id == item.item_id ? { item_id: lis.item_id, item_name: lis.item_name, item_barcode: lis.item_barcode, item_price: Number(lis.item_price), item_qty: Number(lis.item_qty)+(1*item?.item_unit_one_of_many), item_quantity: lis.item_quantity, item_sell_price: lis.item_sell_price, item_sell_state: lis.item_sell_state, item_unit_many_qty: Number(lis.item_unit_many_qty)+1,item_unit_one: lis.item_unit_one, item_unit_many: lis.item_unit_many, item_unit_one_of_many:lis.item_unit_one_of_many } : lis)
                                    // });
                                } else {
                                    props.setinvoice_detail({
                                      ...props.invoice_detail,
                                      items: [{ item_id: item.item_id, item_name: item.item_name, item_barcode: item.item_barcode, item_price: item.item_price, item_qty: (1*item?.item_unit_one_of_many), item_quantity: item.item_qty, item_sell_price: item.item_price, item_sell_state: "pay", item_unit_one_qty: 0, item_unit_many_qty: 1, item_unit_one: item.item_unit_one, item_unit_many:item.item_unit_many, item_unit_one_of_many:item.item_unit_one_of_many }, ...props.invoice_detail.items]
                                    });
                                }
                              }}
                            >
                              <div className="flex items-center">
                                <span className="text-gray-700">({item?.item_name}) - </span>
                                <span className="text-gray-700">&nbsp;({item?.item_barcode}) - </span>
                                {/* <span className="text-gray-700">&nbsp;({item?.item_unit_one} {Math.floor(item.item_qty)}/{Math.round((Number(item.item_qty)-Number(Math.floor(item.item_qty)))*item.item_unit_one_of_many)} {item?.item_unit_many}) - </span> */}
                                <span className="text-gray-700">&nbsp;({item?.item_unit_one} {money_rounding(Math.floor(item?.item_qty/item?.item_unit_one_of_many))}/{money_rounding(Number(item?.item_qty) % item?.item_unit_one_of_many)} {item?.item_unit_many}) - </span>
                                <span className="text-gray-700">&nbsp;({numberbeautify(item?.item_price)}$ {"یەک "+item?.item_unit_one}) - </span>
                                <span className="text-gray-700">&nbsp;({numberbeautify(money_rounding(item?.cost_pet_unit_one))}$ {"یەک "+item?.item_unit_one})</span>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                    {props?.invoice_detail?.items?.length <= 0 ? null : (
                      <div className="w-full overflow-x-auto">
                        <table className="min-w-full leading-normal">
                          <thead>
                            <tr>
                              <th className="px-3 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                ناوی کاڵا - کۆد
                              </th>
                              <th className="px-3 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                دۆخی فرۆشتن
                              </th>
                              <th className="px-3 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                نرخ
                              </th>
                              <th className="px-3 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                نرخ (دینار)
                              </th>
                              <th className="px-3 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                بڕ
                              </th>
                              <th className="px-3 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                بڕ - تاک
                              </th>
                              <th className="px-3 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                کۆی نرخ
                              </th>
                              <th className="px-3 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                ڕەشکردنەوە
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {props.invoice_detail.items.map((lis, index) => (
                              <tr key={index}>
                                <td className="px-3 py-4 border-b border-gray-200 bg-white text-sm">
                                  <div className="flex">
                                    <p className="text-gray-900 whitespace-no-wrap ml-1">
                                    {lis.item_name}
                                  </p>
                                  <p className="text-gray-900 whitespace-no-wrap">
                                    -
                                  </p>
                                  <p className="text-gray-900 whitespace-no-wrap mr-1">
                                    {lis.item_barcode}
                                  </p>
                                </div>
                                </td>
                                <td className="px-3 py-4 border-b border-gray-200 bg-white text-sm">
                                  <select
                                    id="item_sell_state"
                                    className={
                                      "w-[120px] lg:w-full bg-gray-50 border border-gray-300 text-gray-700 rounded focus:ring-blue-500 focus:border-blue-500 block py-3 px-4"
                                    }
                                    value={lis.item_sell_state}
                                    onChange={(val) => {
                                      props?.setinvoice_detail({
                                        ...props?.invoice_detail,
                                        items: props?.invoice_detail?.items.map(
                                          (lis, indexx) =>
                                            index == indexx
                                              ? {
                                                  item_id: lis.item_id,
                                                  item_name: lis.item_name,
                                                  item_barcode: lis.item_barcode,
                                                  item_price: lis.item_price,
                                                  item_sell_price: lis.item_price,
                                                  item_qty: lis.item_qty,
                                                  item_quantity: lis.item_quantity,
                                                  item_unit_one: lis.item_unit_one,
                                                  item_unit_many: lis.item_unit_many,
                                                  item_unit_one_of_many: lis.item_unit_one_of_many,
                                                  item_unit_one_qty: lis.item_unit_one_qty,
                                                  item_sell_state: val.target.value,
                                                }
                                              : lis
                                      ),
                                    });
                                  }}
                                >
                                  <option value="pay">فرۆش</option>
                                  <option value="gift">دیاری</option>
                                </select>
                                </td>
                                <td className="px-3 py-4 border-b border-gray-200 bg-white text-sm">
                                  <input
                                    className={
                                    lis.item_sell_state == 'gift'
                                  ? "w-[120px] lg:w-full appearance-none block bg-gray-200 text-gray-500 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-gray-200 focus:border-gray-500"
                                  : "w-[120px] lg:w-full appearance-none block bg-white text-black border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                  }
                                  id="grid-last-name"
                                  type="number"
                                  placeholder=""
                                  disabled={lis.item_sell_state == 'gift' ? true : false}
                                  onClick={(val)=>{val.target.select()}}
                                  value={lis.item_sell_price}
                                  onChange={(val) => {
                                    props?.setinvoice_detail({
                                      ...props?.invoice_detail,
                                      items: props?.invoice_detail?.items.map(
                                        (lis, indexx) =>
                                          index == indexx
                                            ? {
                                                item_id: lis.item_id,
                                                item_name: lis.item_name,
                                                item_barcode: lis.item_barcode,
                                                item_price: lis.item_price,
                                                item_sell_price: val.target.value,
                                                item_qty: lis.item_qty,
                                                item_quantity: lis.item_quantity,
                                                item_unit_one: lis.item_unit_one,
                                                item_unit_many: lis.item_unit_many,
                                                item_unit_one_of_many: lis.item_unit_one_of_many,
                                                item_unit_one_qty: lis.item_unit_one_qty,
                                                item_sell_state: lis.item_sell_state,
                                              }
                                            : lis
                                      ),
                                    });
                                  }}
                                  // onBlur={()=>{
                                  //   if(Number(lis.item_sell_price)<Number(lis.item_min_sell_price)){
                                  //     alert('ئەم کاڵایە نابێت لە '+numberbeautify(lis.item_min_sell_price)+'کەمتر بفرۆشرێت');
                                  //     // setstopsell(true);
                                  //   }
                                  // }}
                                />
                                </td>
                                <td className="px-3 py-4 border-b border-gray-200 bg-white text-sm">
                                  {numberbeautify(money_rounding(Number(lis.item_sell_price) * Number(props?.invoice_detail?.sell_invoice_dollar_price)))}
                                </td>
                                <td className="px-3 py-4 border-b border-gray-200 bg-white text-sm">
                                  <input
                                    className={
                                    "w-[120px] lg:w-full appearance-none block bg-white text-black border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                  }
                                  id="grid-last-name"
                                  type="number"
                                  placeholder=""
                                  onClick={(val)=>{val.target.select()}}
                                  value={lis.item_unit_many_qty}
                                  onChange={(val) => {
                                      const newManyQty = Number(val.target.value);
                                      const oneQty = Number(lis.item_unit_one_qty);
                                      const oneOfMany = Number(lis.item_unit_one_of_many);
                                      
                                      // Calculate total quantity:
                                      // 1. Contribution from many units (newManyQty * oneOfMany)
                                      // 2. Add contribution from individual units (oneQty)
                                      const totalQty = (newManyQty * oneOfMany) + oneQty;

                                      props?.setinvoice_detail({
                                        ...props?.invoice_detail,
                                        items: props?.invoice_detail?.items.map(
                                          (lis, indexx) =>
                                            index == indexx
                                              ? {
                                                  item_id: lis.item_id,
                                                  item_name: lis.item_name,
                                                  item_barcode: lis.item_barcode,
                                                  item_price: lis.item_price,
                                                  item_sell_price: lis.item_sell_price,
                                                  item_qty: totalQty,
                                                  item_quantity: lis.item_quantity,
                                                  item_unit_one: lis.item_unit_one,
                                                  item_unit_many: lis.item_unit_many,
                                                  item_unit_one_of_many: lis.item_unit_one_of_many,
                                                  item_unit_one_qty: oneQty,
                                                  item_unit_many_qty: newManyQty,
                                                  item_sell_state: lis.item_sell_state,
                                                }
                                              : lis
                                        ),
                                      });
                                  }}
                                />
                                </td>
                                <td className="px-3 py-4 border-b border-gray-200 bg-white text-sm">
                                  <input
                                    className={
                                    "w-[120px] lg:w-full appearance-none block bg-white text-black border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                  }
                                  id="grid-last-name"
                                  type="number"
                                  placeholder=""
                                  onClick={(val)=>{val.target.select()}}
                                  value={lis.item_unit_one_qty}
                                  onChange={(val) => {
                                    const newOneQty = Number(val.target.value);
                                    const manyQty = Number(lis.item_unit_many_qty);
                                    const oldOneQtyContribution = Number(lis.item_unit_one_qty);
                                    const manyQtyContribution = manyQty * Number(lis.item_unit_one_of_many);
                                    const totalQty = manyQtyContribution + newOneQty;
                                    props?.setinvoice_detail({
                                      ...props?.invoice_detail,
                                      items: props?.invoice_detail?.items.map(
                                        (lis, indexx) =>
                                          index == indexx
                                            ? {
                                                item_id: lis.item_id,
                                                item_name: lis.item_name,
                                                item_barcode: lis.item_barcode,
                                                item_price: lis.item_price,
                                                item_sell_price: lis.item_sell_price,
                                                item_qty: totalQty,
                                                item_quantity: lis.item_quantity,
                                                item_unit_one: lis.item_unit_one,
                                                item_unit_many: lis.item_unit_many,
                                                item_unit_one_of_many: lis.item_unit_one_of_many,
                                                item_unit_one_qty: newOneQty,
                                                item_unit_many_qty: manyQty,
                                                item_sell_state: lis.item_sell_state,
                                              }
                                            : lis
                                      ),
                                    });
                                  }}
                                />
                                </td>
                                <td className="px-3 py-4 border-b border-gray-200 bg-white text-sm">
                                  {numberbeautify(money_rounding(
                                    Number(lis.item_sell_price) * (Number(lis.item_qty))
                                  ))} $
                                </td>
                                <td className="px-3 py-4 border-b border-gray-200 bg-white text-sm">
                                  <p className="text-gray-900 whitespace-no-wrap">
                                    <MdDeleteForever
                                    size={28}
                                    color="#e74c3c"
                                    className="cursor-pointer"
                                    onClick={() => {
                                      props.setinvoice_detail({
                                        ...props.invoice_detail,
                                        items: props.invoice_detail.items.filter(
                                          (rs) => rs.item_id != lis.item_id
                                        ),
                                      });
                                    }}
                                  />
                                </p>
                                </td>
                              </tr>
                            ))}
                            <tr>
                              <th
                                className="px-3 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider"
                                colSpan={5}
                              >
                                کۆی نرخ
                              </th>
                              <td 
                                className="px-3 py-4 border-b border-gray-200 bg-white text-sm text-center"
                                colSpan={3}
                              >
                                {numberbeautify(
                                    money_rounding(
                                    props?.invoice_detail?.items?.reduce(
                                      (a, v) =>
                                        (a =
                                        Number(a) +
                                        (v.item_sell_state=="pay"?money_rounding(Number(v.item_sell_price) * (Number(v.item_qty))):0)),
                                    0
                                  )
                                ))} $
                              </td>
                            </tr>
                            {props?.invoice_detail?.sell_invoice_discount>0&&(
                              <tr>
                              <th
                                className="px-3 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider"
                                colSpan={5}
                              >
                                داشکاندن
                              </th>
                              <td 
                                className="px-3 py-4 border-b border-gray-200 bg-white text-sm text-center"
                                colSpan={3}
                              >
                                {numberbeautify(money_rounding(
                                    Number(props?.invoice_detail?.items?.reduce(
                                      (a, v) =>
                                        (a =
                                        Number(a) +
                                        (v.item_sell_state=="pay"?money_rounding(Number(v.item_sell_price) * (Number(v.item_qty))):0)),
                                    0
                                  ))*Number(props?.invoice_detail?.sell_invoice_discount/100)
                                  )
                                )} $
                              </td>
                            </tr>)}
                            <tr>
                              <th
                                className="px-3 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider"
                                colSpan={5}
                              >
                                کۆی گشتی
                              </th>
                              <td 
                                className="px-3 py-4 border-b border-gray-200 bg-white text-sm text-center"
                                colSpan={3}
                              >
                                {numberbeautify(money_rounding(
                                    Number(props?.invoice_detail?.items.reduce(
                                      (a, v) =>
                                        (a =
                                        Number(a) +
                                        (v.item_sell_state=="pay"?money_rounding(Number(v.item_sell_price) * (Number(v.item_qty))):0)),
                                    0
                                  ))*Number(1-props?.invoice_detail?.sell_invoice_discount/100)
                                  )
                                )} $
                              </td>
                            </tr>
                            <tr>
                              <th
                                className="px-3 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider"
                                colSpan={5}
                              >
                                کۆی گشتی - دینار
                              </th>
                              <td 
                                className="px-3 py-4 border-b border-gray-200 bg-white text-sm text-center"
                                colSpan={3}
                              >
                                {numberbeautify(iqd_rounding((money_rounding(
                                    Number(props?.invoice_detail?.items.reduce(
                                      (a, v) =>
                                        (a =
                                        Number(a) +
                                        (v.item_sell_state=="pay"?money_rounding(Number(v.item_sell_price) * (Number(v.item_qty))):0)),
                                    0
                                  ))*Number(1-props?.invoice_detail?.sell_invoice_discount/100)
                                  ))*Number(props?.invoice_detail?.sell_invoice_dollar_price))
                                )} IQD
                              </td>
                            </tr>
                            {props?.invoice_detail?.sell_invoice_type=="loan"&&(
                              <tr>
                                <th
                                  className="px-3 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider"
                                  colSpan={5}
                                >
                                  بڕی واسڵکراو
                                </th>
                                <td 
                                  className="px-3 py-2 border-b border-gray-200 bg-white text-sm text-center"
                                  colSpan={3}
                                >
                                  <input
                                      className={
                                      error3
                                        ? "w-[120px] lg:w-full appearance-none block bg-gray-50 text-gray-700 border border-red-500 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12":
                                          "w-[120px] lg:w-full appearance-none block bg-white text-black border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12"
                                    }
                                    id="grid-last-name"
                                    type="number"
                                    onClick={(val)=>{val.target.select()}}
                                    value={props?.invoice_detail?.sell_invoice_loan_in_amount}
                                    onChange={(val) => {
                                      props?.setinvoice_detail({...props?.invoice_detail, sell_invoice_loan_in_amount: val.target.value})
                                    }}
                                  />
                                </td>
                              </tr>
                              )}
                              {props?.invoice_detail?.sell_invoice_type=="loan"&&(
                                <tr>
                                  <th
                                    className="px-3 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider"
                                    colSpan={5}
                                  >
                                    کۆی ماوە
                                  </th>
                                  <td 
                                    className="px-3 py-4 border-b border-gray-200 bg-white text-sm text-center"
                                    colSpan={3}
                                  >
                                    {numberbeautify(money_rounding(
                                        Number(props?.invoice_detail?.items?.reduce(
                                          (a, v) =>
                                            (a =
                                              Number(a) +
                                              (v.item_sell_state=="pay"?money_rounding(Number(v.item_sell_price) * (Number(v.item_qty))):0)),
                                        0
                                      ))*Number(1-props?.invoice_detail?.sell_invoice_discount/100)-Number(props?.invoice_detail?.sell_invoice_loan_in_amount)
                                    )
                                    )} $
                                  </td>
                                </tr>
                              )}
                              {props?.invoice_detail?.sell_invoice_type=="loan"&&(
                                <tr>
                                  <th
                                    className="px-3 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider"
                                    colSpan={5}
                                  >
                                    کۆی ماوە - دینار
                                  </th>
                                  <td 
                                    className="px-3 py-4 border-b border-gray-200 bg-white text-sm text-center"
                                    colSpan={3}
                                  >
                                    {numberbeautify(iqd_rounding((money_rounding(
                                      Number(props?.invoice_detail?.items?.reduce(
                                        (a, v) =>
                                          (a =
                                            Number(a) +
                                            (v.item_sell_state=="pay"?money_rounding(Number(v.item_sell_price) * (Number(v.item_qty))):0)),
                                      0
                                    ))*Number(1-props?.invoice_detail?.sell_invoice_discount/100)-Number(props?.invoice_detail?.sell_invoice_loan_in_amount)
                                  ))*Number(props?.invoice_detail?.sell_invoice_dollar_price))
                                    )} IQD
                                  </td>
                                </tr>
                              )}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                </div>
                {/*footer*/}
                <div className="flex flex-col sm:flex-row items-center justify-end p-4 border-t border-solid border-slate-200 rounded-b gap-2">
                  {/* <button
                    className="bg-slate-600 text-white active:bg-slate-800 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={() => {
                      props.printit(props.invoice_detail.sell_invoice_id);
                    }}
                  >
                    پرینت
                  </button> */}
                  <button
                    className="bg-slate-600 text-white active:bg-slate-800 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150 w-full sm:w-auto"
                    type="button"
                    onClick={() => {
                        setTimeout(() => {
                          printFn();
                        }, 500);
                    }}
                  >
                    پرینت
                  </button>
                  <button
                    className="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150 w-full sm:w-auto"
                    type="button"
                    onClick={() => {
                      if (
                        window.confirm("ئاگاداری ڕەشکردنەوە . دڵنیای ؟") == true
                      ) {
                        deleteaction(props.invoice_detail.sell_invoice_id)(
                          recaller
                        )(setrecaller)(initDispatch)(clear);
                      }
                    }}
                  >
                    ڕەشکردنەوە
                  </button>
                  <button
                    className={sell_loading?"bg-emerald-300 text-white font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150 w-full sm:w-auto":
                      "bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150 w-full sm:w-auto"}
                    type="button"
                    disabled={sell_loading}
                    onClick={() => {
                      if(props.invoice_detail.sell_invoice_discount<0 || props.invoice_detail.sell_invoice_discount>100){
                        seterror1(true);
                        return false;
                      }
                      if(props.invoice_detail.sell_invoice_dollar_price<=0){
                        seterror2(true);
                        return false;
                      }
                      if(props?.invoice_detail?.sell_invoice_type=="loan" && Number(props?.invoice_detail?.sell_invoice_loan_in_amount)<0){
                        seterror3(true);
                        return false;
                      }
                      if (
                        window.confirm("ئاگاداری گۆڕانکاری . دڵنیای ؟") == true
                      ) {
                        if(props?.invoice_detail?.sell_invoice_type=="cash"){
                          props?.setinvoice_detail({...props?.invoice_detail, sell_invoice_loan_in_amount: 0});
                        }
                        setsell_loading(true);
                        updateaction(
                          props.invoice_detail.sell_invoice_id,
                          props.invoice_detail.sell_invoice_type,
                          props.invoice_detail.sell_invoice_discount,
                          props.invoice_detail.sell_invoice_dollar_price,
                          props?.invoice_detail?.sell_invoice_loan_in_amount,
                          props.invoice_detail.customer_id,
                          props?.invoice_detail?.sell_invoice_customer_name,
                          props?.invoice_detail?.sell_invoice_customer_address,
                          props?.invoice_detail?.sell_invoice_customer_phone,
                          props.invoice_detail.items
                        )(recaller)(setrecaller)(initDispatch)(clear)(props.printit)(setsell_loading);
                      }
                    }}
                  >
                    {sell_loading?<div className="flex items-center justify-center space-x-2">
                            <svg
                              className="animate-spin h-5 w-5 text-white"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                            >
                              <circle
                              className="opacity-25"
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="currentColor"
                              strokeWidth="4"
                              ></circle>
                              <path
                              className="opacity-75"
                              fill="currentColor"
                              d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                              ></path>
                            </svg>
                        </div>:"گۆڕانکاری"}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
};

export default Sellinvoicedetailmodal;
